﻿(function ($, d) {
  $(d).ready(function () {
    var dropdowns = d.querySelectorAll('[data-account-dropdown]');
    for (var i = 0; i < dropdowns.length; i++) {
      var $this = dropdowns[i];
      dropdowns[i].querySelector('.expand-button').addEventListener('click', function () {
        if (this.parentElement.classList.contains('balance-breakdown--open')) {
          this.parentElement.classList.remove('balance-breakdown--open');
          this.parentElement.querySelector('[data-expand-icon]').innerText = 'expand_more';
        }
        else {
          this.parentElement.classList.add('balance-breakdown--open');
          this.parentElement.querySelector('[data-expand-icon]').innerText = 'expand_less';
        }
      })
    }
  });
})(jQuery, document);